import { render, staticRenderFns } from "./betnanoLogin.vue?vue&type=template&id=03187c83&scoped=true"
import script from "./betnanoLogin.vue?vue&type=script&lang=js"
export * from "./betnanoLogin.vue?vue&type=script&lang=js"
import style0 from "./betnanoLogin.vue?vue&type=style&index=0&id=03187c83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03187c83",
  null
  
)

export default component.exports